import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class AlertMessage extends Component<any> {
  render() {
    const { show } = this.props;
    return (
      <Modal
        centered
        show={show}
        className={'profile-modal'}
        onHide={this.props.handleClose}
      >
        {/* @ts-ignore */}
        <Modal.Header className="align-items-center justify-content-center">
          <h3 className="mb-0 title">Welcome to Lokem!</h3>
        </Modal.Header>
        <Modal.Body>
          <p className="text-left">
            You're only a couple steps away from completely customized courses, but first we need to get to know you a bit. Fill out the fields with a <span className="mandatory">red * </span>and we can begin to work our magic.</p>
          <p className="text-left">What's next, you ask? <b>Lokem</b> uses the information that you provide in your profile to help modify each course, and deliver content that is the most relevant to you. We know that your job, years of experience, and education don't define you, but they do help us begin to make your training experience better. See you inside! </p>
          <div className='text-center mt-4'>
            <Button
              type='submit'
              variant='link'
              className='btn-submit text-uppercase'
              onClick={this.props.handleClose}
            >
              Got it!
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AlertMessage;
